import { Flex, Result, Spin } from 'antd'
import { useState, useMemo, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import * as dd from 'dingtalk-jsapi'

const DINGTALK_CLIENT_ID = 'dingwgdx6emlxr3fcrg8'
const DINGTALK_JSAPI_CLIENT_ID = 'dingl3jyntkazyg4coxf'
const DINGTALK_CORP_ID = 'ding48bce8fd3957c96b'
const CALLBACK_URI = 'https://sales.mycht.cn/p/dingding/callback'

// 获取微应用免登授权码
// https://open.dingtalk.com/document/orgapp/jsapi-request-auth-code
function Login() {
  const navigate = useNavigate()
  const [errorMsg, setErrorMsg] = useState('')

  const originUrl = useMemo(() => {
    const urlSearch = new URLSearchParams(location.search)
    return urlSearch.get('origin_url') || ''
  }, [])

  const redirectUrl = useMemo(() => {
    const encodedCallback = encodeURIComponent(CALLBACK_URI + '?origin_url=' + originUrl)
    return (
      'https://login.dingtalk.com/oauth2/auth' +
      '?redirect_uri=' + encodedCallback +
      '&response_type=code' +
      '&client_id=' + DINGTALK_CLIENT_ID +
      '&scope=openid' +
      '&state=global-sales' +
      '&prompt=consent'
    )
  }, [originUrl])

  useEffect(() => {
    if (import.meta.env.DEV) return

    const platform = dd?.env?.platform

    if (platform === 'notInDingTalk') {
      window.location.assign(redirectUrl)
      return
    }

    dd.requestAuthCode({
      clientId: DINGTALK_JSAPI_CLIENT_ID,
      corpId: DINGTALK_CORP_ID,
      success: ({ code }) => {
        navigate(
          '/p/dingding/callback?origin_url=' +
            originUrl +
            '&state=jsapi-auth&authCode=' +
            code,
          { replace: true },
        )
      },
      fail: (error) => {
        setErrorMsg(JSON.stringify(error))
      },
    })
  }, [navigate, originUrl, redirectUrl])

  if (import.meta.env.DEV) {
    return (
      <Flex justify='center' align='center' gap='middle' vertical>
        <Result
          status='warning'
          title='你处于开发模式'
          subTitle='请先设置 Local storage'
          extra={[<Spin key='dingding-login' size='small' />]}
        />
      </Flex>
    )
  }

  return (
    <Flex justify='center' align='center' gap='middle' vertical>
      <Result
        status={errorMsg ? 'error' : 'success'}
        title='欢迎使用'
        subTitle={errorMsg ? '授权失败：' + errorMsg : '正在获取钉钉授权'}
        extra={[<Spin key='dingding-login' size='small' />]}
      />
    </Flex>
  )
}

export default Login
